import { ADDRESS_DEFAULT } from 'constants/index';
export const BRANCH_DEFAULT_DATA = {
    branchName: '',
    NMLS: '',
    Address: ADDRESS_DEFAULT,
    phone: '',
    fax: '',
    email: '',
    telNumber: '',
    website: '',
    branchLocation: '',
    Statelicenses: []
};

export const COMPANY_DEFAULT_DATA = {
    name: '',
    NMLS: '',
    mailingaddress: ADDRESS_DEFAULT,
    Address: ADDRESS_DEFAULT,
    phone: '',
    fax: '',
    email: '',
    website: '',
    FormedIn: '',
    dateFormed: null,
    Statelicenses: [],
    isMailingAddressEqualPhysical: false
};
export const COMPANY_LICENSE_DEFAULTS = {
    regulator: '',
    licRegName: '',
    AuthorizedToConsuctBussiness: 'YES',
    NMLS: ''
};
